// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__38jS4","checkboxCol":"Table_checkboxCol__2dnwB","emailCol":"Table_emailCol__2W5B5","actionCol":"Table_actionCol__3yDbs"};